export enum WebSocketMessageTypes {
  LOG_UPDATED = 'LOG_UPDATED',
  EVENT = 'EVENT',
  SHOW_HIDE_STREAM = 'SHOW_HIDE_STREAM',
  ACTIVITY_EVENT_CREATED = 'ACTIVITY_EVENT_CREATED',
  ACTIVITY_EVENT_REVIEWED = 'ACTIVITY_EVENT_REVIEWED',
  STREAM_STATUS = 'STREAM_STATUS',
}
export type WebSocketMessage<T> = {
  event: WebSocketMessageTypes;
  data: T;
};

export type ShowHideInStreamMessage = {
  patientId: string;
  inMonitoringHours: boolean;
};
